import { Box } from '@mui/material';
import { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';

import Alert from '@Components/Alert';
import commonConstants from '@Constants/common.constants';
import { selectAuthState } from '@Selectors/auth.selector';
import { hideAlert, resetAlert } from '@Slices/globalAlert.slice';
import { useAppDispatch, useAppSelector } from '@Utils/hooks/useStore.hook';

const GlobalErrorAlert: FunctionComponent = () => {
  const alert = useAppSelector((state) => state.alert);
  const userState = useAppSelector(selectAuthState);
  const { t } = useTranslation();
  const dispatch = useAppDispatch();

  /**
   * Accepts the error code/string from backend and returns appropriate message
   * @param errorCode The error code from backend
   * @returns translated string of the error message
   */
  const getErrorMessage = (errorCode: string | undefined): string => {
    switch (errorCode) {
      case commonConstants.GLOBAL_ERROR_CODES.INVALID_USER_ID:
      case commonConstants.GLOBAL_ERROR_CODES.TOKEN_NOT_FOUND:
      case commonConstants.GLOBAL_ERROR_CODES.PARSING_ERROR:
      case commonConstants.GLOBAL_ERROR_CODES.BAD_REQUEST:
      case commonConstants.GLOBAL_ERROR_CODES.FETCH_ERROR:
        return t(`alertMessages.${errorCode}`);
      default:
        return t(
          `alertMessages.${commonConstants.GLOBAL_MESSAGES.GENERIC_ERROR_MESSAGE}`
        );
    }
  };

  /**
   * Close the global alert and then reset the global error object
   */
  const closeAlert = () => {
    dispatch(hideAlert());
    setTimeout(() => {
      dispatch(resetAlert());
    }, commonConstants.ALERT_HIDING_TIME);
  };
  return (
    <Box
      position="fixed"
      top="0"
      left={`${commonConstants.SIDE_MENU_MAX_WIDTH}rem`}
      width={`calc(100% - ${commonConstants.SIDE_MENU_MAX_WIDTH}rem)`}
      zIndex="1205"
    >
      <Alert
        open={alert.isVisible}
        text={getErrorMessage(alert.error?.message)}
        severity={alert.error?.severity}
        closeBtnProps={{
          onClick: closeAlert,
        }}
        onClose={closeAlert}
        className={userState?.isLoggedIn ? 'base-alert' : ''}
        sx={{
          '&.base-alert': {
            position: 'absolute',
            top: '5.6rem',
            left: '50%',
            height: '5.6rem',
            transform: 'translateX(-50%)',
          },
        }}
      />
    </Box>
  );
};

export default GlobalErrorAlert;
